export const MAX_NUMBER_OF_ENTITIES_FROM_SERVER = 75;
